// extracted by mini-css-extract-plugin
module.exports = {"time_left_item":"time-left-box_time_left_item__Kfcla","time_left_date_count":"time-left-box_time_left_date_count__8qJEI","time_title":"time-left-box_time_title__scEhZ"};